import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

type Props = {
  markdown: string;
};

const normalizeMarkdown = (md: string) => {
  let result = md;

  result = result.replace(/\\n/g, "\n");

  return result.trim();
};


export const CompareMarkdownView: React.FC<Props> = ({ markdown }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => (
          <Section title={children} level={1} />
        ),
        h2: ({ children }) => {
          const text = String(children);

          // 「結論の要約」を特別扱い
          if (text.includes("結論")) {
            return <ConclusionBox title={children} />;
          }

          return <Section title={children} level={2} />;
        },
        ul: ({ children }) => (
          <ul className="list-disc pl-6 space-y-2">{children}</ul>
        ),
        li: ({ children }) => (
          <li className="text-sm leading-relaxed">{children}</li>
        ),
        table: ({ children }) => (
          <div className="overflow-x-auto my-6">
            <table className="min-w-full border border-gray-300 text-sm">
              {children}
            </table>
          </div>
        ),
        th: ({ children }) => (
          <th className="border px-3 py-2 bg-gray-100 font-bold text-left">
            {children}
          </th>
        ),
        td: ({ children }) => (
          <td className="border px-3 py-2">{children}</td>
        ),
        hr: () => <hr className="my-8 border-gray-300" />,
      }}
    >
      {normalizeMarkdown(markdown)}
    </ReactMarkdown>
  );
};

const Section = ({
  title,
  level,
}: {
  title: React.ReactNode;
  level: 1 | 2;
}) => {
  return (
    <div className="my-6">
      <h2
        className={`font-bold ${
          level === 1 ? "text-xl" : "text-lg"
        } mb-3`}
      >
        {title}
      </h2>
    </div>
  );
};

const ConclusionBox = ({ title }: { title: React.ReactNode }) => {
  return (
    <div className="my-6 rounded-lg border-l-4 border-blue-500 bg-blue-50 p-4">
      <h2 className="font-bold text-lg mb-2">{title}</h2>
    </div>
  );
};

